<div class="wrapper" [class.sidebar-open]="sidebarOpen">
  <div class="header-menu">
    <i class="material-icons" (click)="toggleSidebar()">menu</i>
  </div>
  <div
    class="sidebar"
    data-color="azure"
    data-background-color="black"
    data-image="./assets/img/sidebar-1.jpg"
  >
    <app-sidebar-cmp></app-sidebar-cmp>
  </div>
  <div class="main-panel">
    <app-navbar-cmp></app-navbar-cmp>
    <router-outlet></router-outlet>
    <div *ngIf="!isMap()">
      <app-footer-cmp></app-footer-cmp>
    </div>
  </div>
</div>
